import * as formatter from "../../../../utils/formatter";

export const columns = [
  {
    keyField: "no",
    dataField: "no",
    text: "No.",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "goodsNo",
    text: "상품 코드",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "catNm1",
    text: "카테고리",
    headerClasses: 'text-center',
    classes: 'text-left',
    formatter: formatter.category,
  },
  {
    keyField: "no",
    dataField: "goodsNm",
    text: "상품명",
    headerClasses: 'text-center',
    classes: 'text-left',
    formatter: formatter.prodName,
  },
  {
    keyField: "no",
    dataField: "normalPrc",
    text: "정가",
    headerClasses: 'text-center',
    classes: 'text-right',
    formatter: formatter.price,
  },
  {
    keyField: "no",
    dataField: "salePrc",
    text: "판매가",
    headerClasses: 'text-center',
    classes: 'text-right',
    formatter: formatter.price,
  },
  {
    keyField: "no",
    dataField: "splyNm",
    text: "공급파트너",
    headerClasses: 'text-center',
    classes: 'text-right',
  },
  {
    keyField: "no",
    dataField: "regDtime",
    text: "상품 등록일",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.date
  },
];
